/*
 * @flow
 */
import axios from 'axios';
import * as globals from '../constants/globals';
import { makeAsyncAction } from '../utils/async_utils';
import { POST_REVIEW_FLAG_FAILURE, POST_REVIEW_FLAG_START, POST_REVIEW_FLAG_SUCCESS } from '../constants/types';

export type flagRequest = {
  reservation_id: string,
  reason: boolean,
};

export const postReviewFlagEndpoint = () => `${globals.API_URL}/review/flag`;

const postReviewFlagApi = (data: flagRequest) => () => axios.post(postReviewFlagEndpoint(), data);

export const postReviewFlag = makeAsyncAction(
  { startType: POST_REVIEW_FLAG_START, successType: POST_REVIEW_FLAG_SUCCESS, failureType: POST_REVIEW_FLAG_FAILURE },
  postReviewFlagApi,
  true,
  'data'
);
